import React, { useEffect, useState } from 'react';
import { LightPlayer } from '../../types/types';
import { TRIMMEDPOSITIONLIST } from '../../globals/Globals';
import { FormControl, InputLabel, MenuItem, Paper, Select, TextField } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import InputAdornment from '@mui/material/InputAdornment';
import _ from 'underscore';

export interface Props {
    players: LightPlayer[];
    setPlayers: (players:LightPlayer[]) => void;
    resetPlayers: () => void;
}

const FindPlayersInput = ({players, setPlayers, resetPlayers}:Props) => {
    const [ selectedPositions, setPositions ] = useState("*");
    const [ selectedPrice, setSelectedPrice ] = useState(0);
    const [ selectedPriceDirection, setSelectedPriceDirection ] = useState(">");
    const [ priceInputValue, setPriceInputValue ] = useState("");

    const [ selectedBEDirection, setSelectedBEDirection ] = useState(">");
    const [ BEInputValue, setBEInputValue ] = useState("");
    const [ selectedBE, setSelectedBE ] = useState(0);

    const [ selectedPointsDirection, setSelectedPointsDirection ] = useState(">");
    const [ PointsInputValue, setPointsInputValue ] = useState("");
    const [ selectedPoints, setSelectedPoints ] = useState(0);

    const [ selectedBWLSRDirection, setSelectedBWLSRDirection ] = useState(">");
    const [ BWLSRInputValue, setBWLSRInputValue ] = useState("");
    const [ selectedBWLSR, setSelectedBWLSR ] = useState(0);

    const [ selectedBATSRDirection, setSelectedBATSRDirection ] = useState(">");
    const [ BATSRInputValue, setBATSRInputValue ] = useState("");
    const [ selectedBATSR, setSelectedBATSR ] = useState(0);

    console.log("Find Players input: ", players);
    function FilterChange() {
        let newplayers = players.slice();
        let keepplayers:LightPlayer[] = [];
        
        newplayers.map(function(player) {
            let include = true;
            const lastgame = player.stats[0].lastgame;
            const playerstats = player.stats[0];

            if (selectedPositions !== "*") {
                let playerpositions:string[] = [];
                
                player.positions.map(function(position) {
                    playerpositions.push(position.name);
                });
                if (!playerpositions.includes(selectedPositions)) {
                    include = false;
                }
                
            }
            if (selectedPrice !== 0) {
                if (selectedPriceDirection === ">") {
                    if (lastgame.price < selectedPrice) {
                        include = false;
                    }
                } else {
                    if (lastgame.price > selectedPrice) {
                        include = false;
                    }
                }
            }
            if (selectedBE !== 0) {
                if (selectedBEDirection === ">") {
                    if (lastgame.scbe < selectedBE) {
                        include = false;
                    }
                } else {
                    if (lastgame.scbe > selectedBE) {
                        include = false;
                    }
                }
            }
            if (selectedPoints !== 0) {
                if (selectedPointsDirection === ">") {
                    if (playerstats.avgpts < selectedPoints) {
                        include = false;
                    }
                } else {
                    if (playerstats.avgpts > selectedPoints) {
                        include = false;
                    }
                }
            }
            
            if (selectedBWLSR !== 0) {
                if (selectedBWLSRDirection === ">") {
                    if (player.bwlStrikeStat.avgSR < selectedBWLSR) {
                        include = false;
                    }
                } else {
                    if (player.bwlStrikeStat.avgSR < selectedBWLSR) {
                        include = false;
                    }
                }
            }

            if (selectedBATSR !== 0) {
                if (selectedBATSRDirection === ">") {
                    if (player.batStrikeStat.avgSR < selectedBATSR) {
                        include = false;
                    }
                } else {
                    if (player.batStrikeStat.avgSR < selectedBATSR) {
                        include = false;
                    }
                }
            }
            if (include) {
                keepplayers.push(player);
            }
        });
        
        setPlayers(keepplayers);
    }

    function onPositionChange(changeevent:SelectChangeEvent<string>) {
        let newvalues = changeevent.target.value;
        setPositions(newvalues);
        
    }

    function onPriceChange(changeevent:React.ChangeEvent<HTMLInputElement>) {
        let newprice = changeevent.target.value;
        if (!isNaN(parseInt(newprice))) {
            setSelectedPrice(parseInt(newprice));
        }
        setPriceInputValue(newprice);
    }

    function onBEChange(changeevent:React.ChangeEvent<HTMLInputElement>) {
        let newBE = changeevent.target.value;
        if (!isNaN(parseInt(newBE))) {
            setSelectedBE(parseInt(newBE));
        }
        setBEInputValue(newBE);
    }


    function onPTSChange(changeevent:React.ChangeEvent<HTMLInputElement>) {
        let newPTS = changeevent.target.value;
        if (!isNaN(parseInt(newPTS))) {
            setSelectedPoints(parseInt(newPTS));
        }
        setPointsInputValue(newPTS);
    }

    function onBATSRChange(changeevent:React.ChangeEvent<HTMLInputElement>) {
        let newBATSR = changeevent.target.value;
        if (!isNaN(parseInt(newBATSR))) {
            setSelectedBATSR(parseInt(newBATSR));
        }
        setBATSRInputValue(newBATSR);
    }

    function onBWLSRChange(changeevent:React.ChangeEvent<HTMLInputElement>) {
        let newBWLSR = changeevent.target.value;
        if (!isNaN(parseInt(newBWLSR))) {
            setSelectedBWLSR(parseInt(newBWLSR));
        }
        setBWLSRInputValue(newBWLSR);
    }

    

    

    useEffect(() => {
        FilterChange();
    },[selectedPositions, selectedPrice,selectedPriceDirection, selectedBE,selectedPoints, selectedPriceDirection,selectedBEDirection, selectedPointsDirection, selectedBATSR, selectedBWLSR])

    return <div elevation={5} style={{display: "flex", marginTop: "1rem", columnGap: "1rem",marginBottom: "1rem", overflowY: "scroll"}}>
        <div>
        <InputLabel id={'positioninputlabel'} style={{marginBottom: "0.5rem"}}>Position</InputLabel>
        <FormControl sx={{display: "flex", flexDirection: "column", justifyContent: 'flex-start', alignItems: "flex-start"}}> 
            
            <Select
                value={selectedPositions}
                label="Position"
                onChange={e => onPositionChange(e)}
                labelId={'positioninputlabel'}
            >
                <MenuItem value={"*"}>Any</MenuItem>
                {TRIMMEDPOSITIONLIST.map(function(position) {
                    return <MenuItem value={position}>{position}</MenuItem>
                })}
                
            </Select>
        </FormControl>
        </div>
        <div>
            <InputLabel id={'positioninputlabel1'} style={{marginBottom: "0.5rem"}}>Price</InputLabel>
            <FormControl size="small" sx={{display: "flex", flexDirection: "row"}}>
                <InputLabel id={'positiondirectionlabel1'} style={{marginBottom: "0.5rem"}}>Direction</InputLabel>
                <Select
                    value={selectedPriceDirection}
                    label="Direction"
                    onChange={e => {setSelectedPriceDirection(e.target.value); }}
                    sx={{width: "80px"}}
                >
                    <MenuItem value="<">{'<'}</MenuItem>
                    <MenuItem value=">">{'>'}</MenuItem>
                </Select>
                <TextField
                    label="Price"
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    value={priceInputValue}
                    onChange={onPriceChange}
                />
            </FormControl>
        </div>
        <div>
            <InputLabel id={'beinputlabel'} style={{marginBottom: "0.5rem"}}>Break Even</InputLabel>
            <FormControl size="small" sx={{display: "flex", flexDirection: "row"}}>
                <InputLabel id={'bedirectionlabel'} style={{marginBottom: "0.5rem"}}>Direction</InputLabel>
                <Select
                    value={selectedPriceDirection}
                    label="Direction"
                    onChange={e => {setSelectedPriceDirection(e.target.value); }}
                    sx={{width: "80px"}}
                >
                    <MenuItem value="<">{'<'}</MenuItem>
                    <MenuItem value=">">{'>'}</MenuItem>
                </Select>
                <TextField
                    label="Breakeven"
                    value={BEInputValue}
                    onChange={onBEChange}
                />
            </FormControl>
        </div>

        <div>
            <InputLabel id={'ptsinputlabel'} style={{marginBottom: "0.5rem"}}>AVG Pts</InputLabel>
            <FormControl size="small" sx={{display: "flex", flexDirection: "row"}}>
                <InputLabel id={'ptsdirectionlabel'} style={{marginBottom: "0.5rem"}}>Direction</InputLabel>
                <Select
                    value={selectedPointsDirection}
                    label="Direction"
                    onChange={e => {setSelectedPointsDirection(e.target.value); }}
                    sx={{width: "80px"}}
                >
                    <MenuItem value="<">{'<'}</MenuItem>
                    <MenuItem value=">">{'>'}</MenuItem>
                </Select>
                <TextField
                    label="Pts"
                    value={PointsInputValue}
                    onChange={onPTSChange}
                />
            </FormControl>
        </div>
        <div>
            <InputLabel id={'BATSRinputlabel'} style={{marginBottom: "0.5rem"}}>BAT SR</InputLabel>
            <FormControl size="small" sx={{display: "flex", flexDirection: "row"}}>
                <InputLabel id={'BATSRdirectionlabel'} style={{marginBottom: "0.5rem"}}>Direction</InputLabel>
                <Select
                    value={selectedBATSRDirection}
                    label="Direction"
                    onChange={e => {setSelectedBATSRDirection(e.target.value); }}
                    sx={{width: "80px"}}
                >
                    <MenuItem value="<">{'<'}</MenuItem>
                    <MenuItem value=">">{'>'}</MenuItem>
                </Select>
                <TextField
                    label="BWL SR"
                    value={BATSRInputValue}
                    onChange={onBATSRChange}
                />
            </FormControl>
        </div>
        <div>
            <InputLabel id={'bwlSRinputlabel'} style={{marginBottom: "0.5rem"}}>BWL SR</InputLabel>
            <FormControl size="small" sx={{display: "flex", flexDirection: "row"}}>
                <InputLabel id={'BWLSRdirectionlabel'} style={{marginBottom: "0.5rem"}}>Direction</InputLabel>
                <Select
                    value={selectedBWLSRDirection}
                    label="Direction"
                    onChange={e => {setSelectedBWLSRDirection(e.target.value); }}
                    sx={{width: "80px"}}
                >
                    <MenuItem value="<">{'<'}</MenuItem>
                    <MenuItem value=">">{'>'}</MenuItem>
                </Select>
                <TextField
                    label="BWL SR"
                    value={BWLSRInputValue}
                    onChange={onBWLSRChange}
                />
            </FormControl>
        </div>
       
    </div>
}

export default FindPlayersInput;